import React from "react";
import { Link } from "react-router-dom";
import LayoutOne from "../../layouts/LayoutOne";
import { DPO_CONTACT, POLITICA_ULTIMA_ATUALIZACAO } from "../../config/lgpd";
import bannerBg from "../../assets/img/banner/banner_bg.jpg";

const Privacidade = () => {
  return (
    <LayoutOne>
      <main className="fix">
        <section
          className="breadcrumb-area pt-130 pb-130"
          style={{
            backgroundImage: `url(${bannerBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-8 col-lg-10">
                <div className="breadcrumb-content text-center">
                  <h1 className="title">Política de Privacidade</h1>
                  <p className="text-white-50">
                    Última atualização: {POLITICA_ULTIMA_ATUALIZACAO}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pt-130 pb-130">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="policy-content">
                  <p className="lead">
                    A USYS Tecnologia valoriza a privacidade e a proteção dos
                    dados pessoais de seus clientes, parceiros e visitantes. Esta
                    Política de Privacidade explica de forma transparente como
                    coletamos, utilizamos, armazenamos e protegemos informações
                    pessoais, em conformidade com a Lei Geral de Proteção de
                    Dados – LGPD (Lei nº 13.709/2018).
                  </p>
                  <p>
                    Ao utilizar nosso site, você declara estar ciente das
                    práticas descritas nesta Política.
                  </p>

                  <h2>1. Dados pessoais que podem ser coletados</h2>
                  <p>
                    Durante a navegação em nosso site ou ao utilizar nossos canais
                    de contato, poderemos coletar:
                  </p>
                  <ul>
                    <li>Nome completo</li>
                    <li>Endereço de e-mail</li>
                    <li>Número de telefone</li>
                    <li>Empresa ou organização</li>
                    <li>Cargo ou área de atuação</li>
                    <li>
                      Informações fornecidas voluntariamente em formulários de
                      contato ou comunicação
                    </li>
                  </ul>
                  <p>
                    Também podem ser coletados dados técnicos automaticamente:
                    endereço IP, tipo de navegador e dispositivo, páginas
                    acessadas, data e horário de acesso. Essas informações
                    servem para melhorar a experiência de navegação e garantir o
                    funcionamento adequado do site.
                  </p>

                  <h2>2. Finalidade do uso dos dados</h2>
                  <ul>
                    <li>Responder solicitações enviadas por formulários ou canais de contato</li>
                    <li>Fornecer informações sobre serviços oferecidos pela empresa</li>
                    <li>Manter comunicação com clientes e potenciais parceiros</li>
                    <li>Melhorar a experiência e o desempenho do site</li>
                    <li>Cumprir obrigações legais ou regulatórias</li>
                  </ul>
                  <p>
                    A USYS Tecnologia utiliza apenas os dados necessários para
                    cada finalidade específica.
                  </p>

                  <h2>3. Base legal para o tratamento</h2>
                  <p>
                    O tratamento é realizado com base nas hipóteses legais da
                    LGPD: consentimento do titular, execução de contrato ou
                    procedimentos preliminares, cumprimento de obrigação legal
                    ou regulatória, e legítimo interesse, respeitados os direitos
                    do titular.
                  </p>

                  <h2>4. Uso de cookies</h2>
                  <p>
                    Nosso site pode utilizar cookies e tecnologias similares para
                    garantir o funcionamento da plataforma, analisar o uso do
                    site e coletar informações estatísticas de navegação. O
                    usuário pode configurar o navegador para bloquear ou excluir
                    cookies; isso pode afetar algumas funcionalidades.
                  </p>

                  <h2>5. Compartilhamento de dados</h2>
                  <p>A USYS Tecnologia não comercializa dados pessoais.</p>
                  <p>
                    Os dados poderão ser compartilhados apenas quando necessário
                    com fornecedores e parceiros tecnológicos, prestadores de
                    serviços que auxiliam a empresa, ou para cumprimento de
                    obrigações legais. Adotamos medidas para que os dados sejam
                    tratados com segurança e em conformidade com a legislação.
                  </p>

                  <h2>6. Armazenamento e retenção</h2>
                  <p>
                    Os dados são armazenados apenas pelo período necessário para
                    as finalidades para as quais foram coletados ou para
                    obrigações legais. Após esse período, os dados poderão ser
                    excluídos de forma segura, anonimizados quando possível, ou
                    mantidos quando houver obrigação legal.
                  </p>

                  <h2>7. Direitos dos titulares de dados</h2>
                  <p>Nos termos da LGPD, você possui os seguintes direitos:</p>
                  <ul>
                    <li>Confirmação da existência de tratamento de dados</li>
                    <li>Acesso aos dados pessoais</li>
                    <li>Correção de dados incompletos, inexatos ou desatualizados</li>
                    <li>Anonimização, bloqueio ou eliminação de dados desnecessários ou excessivos</li>
                    <li>Portabilidade dos dados, quando aplicável</li>
                    <li>Revogação do consentimento</li>
                    <li>Solicitação de exclusão dos dados pessoais</li>
                  </ul>
                  <p>
                    Esses direitos podem ser exercidos a qualquer momento por
                    meio do canal de contato do Encarregado de Dados (DPO) ou
                    pela página de{" "}
                    <Link to="/solicitacoes-lgpd">Solicitações LGPD</Link>.
                  </p>

                  <h2>8. Segurança das informações</h2>
                  <p>
                    Adotamos medidas técnicas e administrativas adequadas para
                    proteger os dados pessoais contra acessos não autorizados,
                    perda, alteração ou divulgação indevida, incluindo controles
                    de acesso e boas práticas de segurança da informação.
                  </p>

                  <h2>9. Canal de contato e Encarregado de Dados (DPO)</h2>
                  <p>
                    Para esclarecimentos, solicitações relacionadas a dados
                    pessoais ou exercício de direitos previstos na LGPD, entre em
                    contato com o Encarregado de Proteção de Dados:
                  </p>
                  <ul className="list-unstyled">
                    <li>
                      <strong>E-mail:</strong>{" "}
                      <a href={`mailto:${DPO_CONTACT.email}`}>
                        {DPO_CONTACT.email}
                      </a>
                    </li>
                    <li>
                      <strong>Empresa:</strong> {DPO_CONTACT.empresa}
                    </li>
                  </ul>
                  <p>
                    Você também pode utilizar o formulário de{" "}
                    <Link to="/solicitacoes-lgpd">Solicitações LGPD</Link> para
                    exercer seus direitos.
                  </p>

                  <h2>10. Alterações nesta Política</h2>
                  <p>
                    Esta Política de Privacidade poderá ser atualizada
                    periodicamente. Recomendamos que os usuários revisitem esta
                    página regularmente para se manterem informados sobre como
                    protegemos seus dados.
                  </p>

                  <div className="mt-5 pt-4 border-top">
                    <Link to="/solicitacoes-lgpd" className="btn theme-btn">
                      Exercer meus direitos LGPD
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </LayoutOne>
  );
};

export default Privacidade;
